// extracted by mini-css-extract-plugin
export default {"form":"AccessModal_form__orB+j","buttonsArea":"AccessModal_buttonsArea__XedhW","successMessage":"AccessModal_successMessage__15J2z"};